import React from 'react';

import {AxisDropdown} from '../common/AxisDropdown';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';
import {updateAxisConfig} from './util';

export const XAxis = () => {
  const {config, updateConfig} = useMediaSettingsDrawerContext();
  return (
    <AxisDropdown
      initialValue={config.gridSettings.xAxis}
      onSelectOption={option =>
        updateAxisConfig(option, config, updateConfig, 'xAxis')
      }
      title="X-Axis"
    />
  );
};
